// extracted by mini-css-extract-plugin
export default {"body2":"body-02_body2__8oyoJ","semibold":"body-02_semibold__H7qkc","italic":"body-02_italic__iUbdo","error":"body-02_error__PonwO","link":"body-02_link__DzwrB"};